export function treeToMap(tree, map) {
  return (tree || []).reduce((map, tag) => {
    tag.parent = this
    map[tag.id] = tag
    treeToMap.call(tag, tag.subTags, map)
    return map
  }, map || {})
}

export function searchById(tree, tagId) {
  return (tree || []).reduce((res, tag) => {
    return res || (tag.id == tagId ? tag : searchById(tagId, tag.subTags))
  }, void 0)
}

export function searchByType(tree, type, level) {
  return (tree || []).reduce((level, tag) => {
    if (tag.tagType !== type) {
      return searchByType(tag.subTags, type, level)
    } else {
      level.push(tag)
      return level
    }
  }, level || [])
}

export function getTagIndicators(tag, indicators) {
  let found
  if (tag.dataSources) {
    found = tag.dataSources.reduce((acum, cube) => {
      cube.indicators.forEach(ind => (acum[ind.indicatorId] = { cube: cube, ...ind }))
      return acum
    }, indicators || {})
  } else {
    found = tag.subTags.reduce((acum, tag) => {
      return getTagIndicators(tag, acum)
    }, indicators || {})
  }

  if (indicators) return found
  return Object.entries(found).map(entry => entry[1])
}

export function flatten(root, inPlace) {
  function _flatter(node, flat) {
    if (inPlace) flat.push(node)
    else flat.push({ ...node, children: [] })
    if (node.children) {
      for (let child of node.children) {
        _flatter(child, flat)
      }
    }
    return flat
  }

  if (Array.isArray(root)) {
    return root.reduce((acum, node) => {
      return _flatter(node, acum)
    }, [])
  } else {
    return _flatter(root, [])
  }
}

export function prune(root, filter, inPlace) {
  function _filterer(node) {
    node.isValid = filter[node.id] || false
    return node.isValid || (Array.isArray(node.children) && node.children.length)
  }

  if (!inPlace) root = JSON.parse(JSON.stringify(root))
  let nodes = flatten(root, true).reverse()
  for (let node of nodes) {
    if (node.children) {
      node.children = node.children.filter(_filterer)
    }
  }

  if (Array.isArray(root)) {
    return root.filter(_filterer)
  } else {
    return root
  }
}
